import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const Button = ({ children, variant = 'primary', size = 'md', icon: Icon, loading, disabled, onClick, className = '', ...props }) => {
  const variants = {
    primary: 'bg-gradient-to-b from-[#5A88F5] to-[#4070E8] hover:from-[#4F7DF3] hover:to-[#3660D4] text-white shadow-[0_1px_2px_rgba(0,0,0,0.2),0_4px_12px_rgba(79,125,243,0.25),inset_0_1px_0_rgba(255,255,255,0.1)]',
    secondary: 'bg-[#151F33] hover:bg-[#1A2640] text-[#E6ECF5] border border-[#1F2A44] hover:border-[#2A3654] shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]',
    ghost: 'bg-transparent hover:bg-[rgba(79,125,243,0.08)] text-[#9AA4B2] hover:text-[#E6ECF5]',
    danger: 'bg-[rgba(229,83,61,0.08)] hover:bg-[rgba(229,83,61,0.15)] text-[#E5533D] border border-[#E5533D]/20 hover:border-[#E5533D]/40',
    success: 'bg-[rgba(47,191,113,0.08)] hover:bg-[rgba(47,191,113,0.15)] text-[#2FBF71] border border-[#2FBF71]/20 hover:border-[#2FBF71]/40',
  };
  
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };
  
  return (
    <motion.button
      whileHover={{ scale: disabled ? 1 : 1.02 }}
      whileTap={{ scale: disabled ? 1 : 0.98 }}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center gap-2 rounded-lg font-medium
        transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : Icon ? (
        <Icon className="w-4 h-4" />
      ) : null}
      {children}
    </motion.button>
  );
};

export default Button;
